import { BOTONES } from '../../../../../../../componentes/botones';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { IConfigDeseada } from 'modelos/src';
import { DetallesPerfilesComponent } from '../../detalles-perfiles/detalles-perfiles.component';
import { ILuminariaExtendida } from '../../../../luminarias.types';
import { Lista2Service } from '../../../../../../../auxiliares/servicios/lista2.service';
import { CardHeaderComponent } from '../../../../../../../componentes/card-header/card-header.component';

export interface ConfigDeseadaDialogData {
  luminaria: ILuminariaExtendida | null;
  configDeseada: IConfigDeseada | null;
}

// Poll de la luminaria mientras el modal está abierto. El lado REAL
// (dispositivo.config) cambia cuando el device reporta/echoea, así que sin esto
// el modal queda con el snapshot del momento de abrir y hay que refrescar a
// mano. El lado DESEADO es estable (solo cambia si el usuario reedita el
// perfil), por eso no se pollea.
const POLL_LUMINARIA_SEG = 10;

// Modal que muestra la comparación entre la configuración REAL del dispositivo
// y la configuración deseada (discrepancias + % aplicado). Reusa el componente
// existente `app-detalles-perfiles` — acá es un detalle secundario; la info
// principal vive en la cronología.
@Component({
  selector: 'app-config-deseada-dialog',
  standalone: true,
  imports: [
    MatCardModule,
    BOTONES,
    MatIconModule,
    CardHeaderComponent,
    DetallesPerfilesComponent,
  ],
  templateUrl: './config-deseada-dialog.component.html',
})
export class ConfigDeseadaDialogComponent implements OnInit, OnDestroy {
  readonly dialogRef = inject(MatDialogRef<ConfigDeseadaDialogComponent>);
  readonly data: ConfigDeseadaDialogData = inject(MAT_DIALOG_DATA);
  private readonly lista2 = inject(Lista2Service);

  // Inputs que consume <app-detalles-perfiles>. Arrancan del snapshot del dialog
  // y el REAL se refresca en vivo con el poll.
  luminaria: ILuminariaExtendida | null = this.data.luminaria;
  configDeseada: IConfigDeseada | null = this.data.configDeseada;

  private sub?: Subscription;

  ngOnInit(): void {
    const id = this.data.luminaria?._id;
    if (!id) return;
    // Trae la luminaria con dispositivo.config actualizado cada POLL_LUMINARIA_SEG.
    this.sub = this.lista2.luminaria(id, POLL_LUMINARIA_SEG).subscribe({
      next: (lum) => {
        if (!lum) return;
        // Merge para conservar campos extendidos que el live no traiga; el
        // dispositivo (config real) lo manda el live.
        this.luminaria = {
          ...(this.luminaria ?? {}),
          ...lum,
        } as ILuminariaExtendida;
      },
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
